import { callMethodOnKeydown, isTyping } from '../helpers'
import { state } from '../map_state/state'
import { Renderer } from '../renderer'
import { dragTool } from './drag_tool'

class GroupTool {
  constructor () {
    this.element = document.querySelector('.mct-group-mode')
    this.tab = document.getElementById('mct-groups-tab')
    this.bindEvents()
  }

  bindEvents () {
    this.activate = this.activate.bind(this)
    this.onKeyDown = this.onKeyDown.bind(this)

    this.element?.addEventListener('click', this.activate)
    document.addEventListener('keydown', this.onKeyDown)
  }

  unBindEvents () {
    this.element?.removeEventListener('click', this.activate)
    document.removeEventListener('keydown', this.onKeyDown)
  }

  onKeyDown (event) {
    if (isTyping(event.target)) return
    if (event.key.toLowerCase() === 'g') {
      callMethodOnKeydown(event.target, this.activate)
    }
  }

  syncUi () {
    this.tab?.classList.toggle('show', state.groupMode)
    this.element?.classList.toggle('selected', state.groupMode)
  }

  activate (force) {
    state.groupMode = typeof force === 'boolean' ? force : !state.groupMode
    state.groupMode ? dragTool.enable() : dragTool.deactivate()
    this.syncUi()
    Renderer.render()
  }
}

export let groupTool = null

export function initGroupTool () {
  groupTool = new GroupTool()
  return groupTool
}
